export default "__VITE_ASSET__DGH9QaP5__"